import React, { useState, useEffect, useReducer } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { I18n } from "aws-amplify/utils";
import {
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Tooltip,
  Box,
  Typography,
  Grid,
  Switch,
  Paper,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import InfoIcon from "@mui/icons-material/Info";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import {
  LocalizationProvider,
  MobileDateTimePicker,
  DateTimeField
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useTemplateController } from "context";
import { get } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import ConfirmSuspendAlarmDialog from "./ConfirmSuspendAlarmDialog";
import Draggable from "react-draggable";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/Rome"); // Imposta il fuso orario per l'Italia

const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value;
    if (Array.isArray(audit)) {
      audit.forEach((element) => {
        if (typeof element.timestamp === "number") {
          element.timestamp = dayjs(element.timestamp).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      });
      return { audit: audit, fetched: true };
    }
  }
  return lastState;
};

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable nodeRef={nodeRef} cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

function SuspendAlarmDialog({
  open,
  onClose,
  onSave,
  alarm,
  setIsLocked,
  isLocked,
  setValueDuration,
  valueDuration,
}) {
  const [remark, setRemark] = useState("");
  const [calendarId, setCalendarId] = useState("");
  const [showCustomDate, setShowCustomDate] = useState(false);
  const [endDate, setEndDate] = useState(
    dayjs().tz().format("YYYY-MM-DD HH:mm:ss")
  );
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    if (open) {
      setRemark("");
      setValueDuration("");
      setIsLocked(false);
      setEndDate(dayjs().tz().format("YYYY-MM-DD HH:mm:ss"));
      setShowCustomDate(false);
      setCalendar("");
      setCalendarId("");
    }
  }, [
    open,
    setRemark,
    setValueDuration,
    setIsLocked,
    setCalendarId,
    setEndDate,
  ]);
  const [calendar, setCalendar] = useState("");
  const [inputFormattedDate, setInputFormattedDate] = useState(
    dayjs(endDate).tz()
  );

  useEffect(() => {
    setInputFormattedDate(dayjs(endDate).tz());
  }, [endDate]);

  const handleConfirmation = () => {
    // console.log("selectedData", valueDuration);
    if (valueDuration === "no-expiration") {
      setConfirmation(true);
    } else {
      handleSave();
    }
  };

  const handleSave = () => {
    const utcEndDate =
      valueDuration === "no-expiration"
        ? ""
        : dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss"); // Converte in UTC
    const selectedData = dropData.find(
      (item) => item.name.trim() === calendar.trim()
    );

    if (selectedData) {
      setCalendarId(selectedData.id.toString());
    } else {
      setCalendarId("");
    }

    onSave(remark, utcEndDate, calendarId); // Passa il valore corretto all'API
    onClose();
    setCalendar("");
    setCalendarId("");
  };

  const handleCalendarChange = (event) => {
    const selectedName = event.target.value;
    setCalendar(selectedName);
    const selectedData = dropData.find(
      (item) => item.name === selectedName.trim().toLowerCase()
    );

    if (selectedData) {
      setCalendarId(selectedData.id);
      // console.log(calendarId)
    }
  };

  const handleDurationChange = (selectedValue) => {
    setValueDuration(selectedValue);
    setShowCustomDate(selectedValue === "custom");

    if (selectedValue === "no-expiration") {
      setEndDate(""); // Imposta endDate su null
    } else if (selectedValue === "custom") {
      // Lascia che l'utente scelga manualmente la data
    } else {
      let newEndDate = dayjs();
      if (typeof selectedValue === "number") {
        newEndDate = newEndDate.add(selectedValue, "hour");
      } else if (selectedValue === "1w") {
        newEndDate = newEndDate.add(1, "week");
      } else if (selectedValue === "1m") {
        newEndDate = newEndDate.add(1, "month");
      }

      setEndDate(newEndDate.tz().format("YYYY-MM-DD HH:mm:ss")); // Mantieni locale
    }
  };
  const durationOptions = [
    { value: 1, label: I18n.get("1 hour") },
    { value: 3, label: I18n.get("3 hours") },
    { value: 6, label: I18n.get("6 hours") },
    { value: 12, label: I18n.get("12 hours") },
    { value: 24, label: I18n.get("24 hours") },
    { value: 48, label: I18n.get("48 hours") },
    { value: "1w", label: I18n.get("1 week") },
    { value: "1m", label: I18n.get("1 month") },
    { value: "no-expiration", label: I18n.get("No Expiration Date") },
    { value: "custom", label: I18n.get("Select Date") },
  ];

  // const isRemarkRequired =
  //   (valueDuration !== "custom" && valueDuration != 3 && valueDuration != 1 && valueDuration != 6 && !remark.trim()) ||
  //   (valueDuration === "custom" &&
  //     (dayjs(inputFormattedDate).diff(dayjs(), "minute") > 360 ||
  //     dayjs().diff(inputFormattedDate, "minute") > 360 ||
  //     !dayjs(inputFormattedDate).isSame(dayjs(), "day")) &&
  //     !remark.trim());
  const isSaveDisabled = !valueDuration || (valueDuration === "custom" && !endDate);
    //  (isLocked && !remark.trim()) || !valueDuration || isRemarkRequired;
  const [controller] = useTemplateController();
  const { darkMode } = controller;
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
  });
  const [dropData, setDropData] = useState([]);
  const data = alarm && alarm.length > 0 ? alarm[0] : {};

  const fetchLists = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/calendar/info/get",
        options: {
          body: {},
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {},
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      setDropData(response);
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Errore durante la chiamata API:", error);
    }
  };
  // console.log(dropData);
  useEffect(() => {
    fetchLists();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle style={{ cursor: "move" }}>
        {I18n.get("Suspend Alarm - ")}
        {alarm.length > 1
          ? "Multiple Alarms Selected"
          : data.original_store +
            " - " +
            data.original_equipment +
            " - " +
            data.alarm_type_description}
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          alignItems="center"
          bgcolor={darkMode ? "#27496d" : "lightblue"}
          p={2}
          borderRadius={1}
          mb={2}
        >
          <InfoIcon sx={{ mr: 1 }} />
          <Typography variant="body2">
            {I18n.get(
              "This section allows you to suspend alarms with or without locking."
            )}
          </Typography>
        </Box>

        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                type="text"
                autoComplete="on"
                label={I18n.get("Note")}
                fullWidth
                multiline
                rows={4}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                // required={isLocked}
                // error={(isLocked && !remark.trim()) || isRemarkRequired}
                // helperText={
                //   (isLocked && !remark.trim()) || isRemarkRequired
                //     ? "This field is required."
                //     : ""
                // }
              />
            </Grid>
            <Grid item xs={12}>
              <label>
                <Tooltip title={isLocked ? "Unlock" : "Unlock"}>
                  <LockOpenIcon />
                </Tooltip>
                <Switch
                  checked={isLocked}
                  onChange={() => setIsLocked(!isLocked)}
                  color="primary"
                />
                <Tooltip title={isLocked ? "Lock" : "Lock"}>
                  <LockIcon />
                </Tooltip>
              </label>
            </Grid>
            {isLocked && (
              <Grid item xs={12}>
                <FormControl margin="dense" fullWidth>
                  {" "}
                  {/** error={!valueDuration} */}
                  <InputLabel>{I18n.get("Calendar")}</InputLabel>
                  <Select
                    label={I18n.get("Calendar")}
                    value={calendar}
                    onChange={handleCalendarChange}
                    fullWidth
                  >
                    {dropData.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {/* {!valueDuration && <Typography color="error">Please select a duration.</Typography>} */}
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12}>
              <FormControl margin="dense" fullWidth error={!valueDuration}>
                <InputLabel>{I18n.get("Duration")}</InputLabel>
                <Select
                  label={I18n.get("Duration")}
                  value={valueDuration}
                  onChange={(e) => handleDurationChange(e.target.value)}
                  fullWidth
                  required
                >
                  {durationOptions.map(({ value, label }) => (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
                {!valueDuration && (
                  <Typography color="error">
                    {I18n.get("Please select a duration.")}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            {showCustomDate && (
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  {/* Used to be MobileDateTimePicker */}
                  <DateTimeField    
                    value={inputFormattedDate}
                    onChange={(newDate) => {
                      if (newDate && dayjs.isDayjs(newDate)) {
                        setInputFormattedDate(newDate);
                        setEndDate(newDate.format("YYYY-MM-DD HH:mm:ss"));
                      }
                    }}
                    format="YYYY/MM/DD HH:mm"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          style: {
                            padding: "4px",
                            fontSize: "14px",
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid> 
            )}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions style={{ cursor: "move" }}>
        <Button onClick={onClose}>{I18n.get("Cancel")}</Button>
        <Button onClick={handleConfirmation} disabled={isSaveDisabled}>
          {I18n.get("Save")}
        </Button>
      </DialogActions>
      <ConfirmSuspendAlarmDialog
        open={confirmation}
        onClose={() => setConfirmation(false)}
        onSave={handleSave}
        onCancel={() => setConfirmation(false)}
      />
    </Dialog>
  );
}

export default SuspendAlarmDialog;
